import view from 'bundle-text:../dom/signUp.html'; // eslint-disable-line
import app from './app';

export default () => {
  const content = document.createElement('div');

  /*
  content.classList.add('align-items-center');
  content.classList.add('d-flex');
  //content.classList.add('h-100');
  content.classList.add('py-5');
  */


  content.classList.add(
    'align-items-center',
    'd-flex',
    'h-auto',
    'justify-content-center',
    //'mh-100',
    'w-100',
  );

  content.innerHTML = view;

  const title = `${app.run.settings.view.signUp.pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;
  document.title = title;

  content.querySelector('#app-form-signUp-passwordConfirm').addEventListener('keyup', () => {
    console.log('SATAN!');
  });

  const form = content.querySelector('#app-form-signUp');
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const data = {};
    const formData = new FormData(form);

    formData.forEach((value, key) => {
      data[key] = value;
    });

    const json = JSON.stringify(data);

    console.log(formData);
    console.log(data);
    console.log(json);

    fetch('/api/sign-up', {
      body: json,
      headers: app.run.headers,
      method: 'POST',
    }).then((response) => {
      console.log(response);
    });
  });

  return content;
};
